/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UndoService } from './undo.service';
import { UndoPanelComponent } from './undo-panel/undo-panel.component';
import { UtilityComponentsModule } from '../utility-components/utility-components.module';
import { MatIconModule } from '@angular/material/icon';

//the angular base
@NgModule({
	imports: [CommonModule, UtilityComponentsModule, MatIconModule],
	declarations: [UndoPanelComponent],
	providers: [UndoService],
	exports: [UndoPanelComponent],
})
export class UndoModule {}
